<template>
  <div id="app">
    <transition name="view">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      isLoading: false
    }
  }
}
</script>

<style lang="scss">
// Import Bulma's core
@import '../node_modules/bulma/sass/utilities/_all';
@import '../node_modules/@mdi/font/css/materialdesignicons.min.css';

// Import FullCalendar
@import "../node_modules/@fullcalendar/core/main.css";
@import "../node_modules/@fullcalendar/daygrid/main.css";
@import "../node_modules/@fullcalendar/timegrid/main.css";

// Set your colors
// #AA0066
$primary: #AA0066;
$primary-invert: findColorInvert($primary);
$info: rgb(14, 165, 192);
$info-invert: findColorInvert($info);
$link: #EE2C98;
$link-invert: findColorInvert($link);

// carousel
$carousel-indicator-border: #EE2C98;
$carousel-arrow-color:#EE2C98;
$carousel-indicator-background: white;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": ($white, $black),
  "black": ($black, $white),
  "light": ($light, $light-invert),
  "dark": ($dark, $dark-invert),
  "primary": ($primary, $primary-invert),
  "info": ($info, $info-invert),
  "success": ($success, $success-invert),
  "warning": ($warning, $warning-invert),
  "danger": ($danger, $danger-invert),
  "link": ($link, $link-invert)
);

// Links
$link: $link;
$link-invert: $link-invert;
$link-focus-border: $link;

// Import Bulma and Buefy styles
@import "../node_modules/bulma";
@import "../node_modules/buefy/src/scss/buefy";
@import "../node_modules/tui-calendar/dist/tui-calendar.min.css";

#app {
  font-family: 'Noto Sans JP', "Montserrat","游ゴシック",YuGothic,"ヒラギノ角ゴ ProN W3","Hiragino Kaku Gothic ProN","メイリオ",Meiryo,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 500;
  text-align: center;
  color: #2c3e50;
  overflow: hidden !important;
}

input, textarea, select {
  background-color: #F8F8F8;
}
input[type=range] {
  -webkit-appearance:none;
  background:#000;
  height: 15px;
  border-radius: 10px !important;
}
input[type=range]::-webkit-slider-thumb{
  -webkit-appearance:none;
  background: rgb(122, 125, 131);
  height:15px;
  width: 30px;
  border-radius: 7.5px;
}
input[type=range]::-ms-tooltip{
  display: none;
}
input[type=range]::-moz-range-track{
  height: 0;
}
input[type=range]::-moz-range-thumb{
  background: rgb(122, 125, 131);
  height:15px;
  width: 30px;
  border:none;
  border-radius: 7.5px;
}
a {
  text-decoration: none;
  color: #C82E42;
}
.button {
  font-weight: bold;
}

.field-label .label {
    text-align: left !important;
}
.message a:not(.button):not(.tag) {
    color: currentColor !important;
    text-decoration: none !important;
    text-decoration-line: none !important;
    text-decoration-style: initial !important;
    text-decoration-color: initial !important;
}
.message a:not(.button):not(.tag) {
    color: currentColor !important;
    text-decoration: none !important;
    text-decoration-line: none !important;
    text-decoration-style: initial !important;
    text-decoration-color: initial !important;
}
.modal {
  z-index: 100001 !important;
}
.modal-background {
  background-color: hsla(0,0%,4%,.76) !important;
}
.b-tabs .tab-content {
  padding: 0 !important;
}
.tabs ul {
    border-bottom-color: #dbdbdb !important;
    border-bottom-style: solid !important;
    border-bottom-width: 1px !important;
}
.is-light {
  border: 2px solid white !important;
}
.b-tooltip.is-bottom.is-multiline.is-small:after {
  width: 108px;
}
//画面全体のスクロールバー制御
::-webkit-scrollbar {
  width:  0px;
  height: 0px;
  visibility: hidden;
}
//画面個別のスクロールバー制御
.disp-scroll {
  overflow: auto !important;
}
.disp-scroll::-webkit-scrollbar {
  width:  15px !important;
  height: 15px !important;
}
*:hover::-webkit-scrollbar {
  visibility: visible;
}
::-webkit-scrollbar-track {
  border: none;
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
}
::-webkit-scrollbar-thumb {
  background-color: rgba(155, 149, 149, 0.5);
  border-radius: 10px;
  box-shadow:0 0 0 1px rgba(255, 255, 255, .3);
}
.is-rounded {
  border-radius: 15px !important;
}
.view-enter-active, .view-leave-active {
  transition: opacity 0.7s;
}
.view-leave-active {
  position: absolute;
}
.view-enter, .view-leave-to {
  opacity: 0;
}
tr.is-mask {
    background: grey;
    color: #fff;
}
.card, .media-content {
  text-align: left !important;
}
// top
.-top-8px {
  margin-top: 8px;
}
// left
.-left-8px {
  margin-left: 8px;
}
// right
.-right-8px {
  margin-right: 8px;
}
.-right-4px {
  margin-right: 4px;
}
// bottom
.-bottom-8px {
  margin-bottom: 8px;
}
// コピー禁止
.not-copy {
  -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none;
}

// datetimepicker
.datepicker .dropdown-content {
  background-color: white;
  border-radius: 8px;
  border: solid thin #ccc !important;
}
.dropdown .background {
  display: none;
}

// Full Calendar Custmize
.calendar-view {
  max-width: 1800px !important;
}
.fc-button-primary {
  background: #f8f8f8 !important;
  border: solid thin #ccc !important;
  color: #222 !important;
}
.fc-widget-header {
  color:#fff !important;
  background:#AA0066 !important;
  text-align: center !important;
  border: none !important;
}
.off-event {
  display: none !important;
}
table tr:nth-child(odd) {
  background:#fcfcfc;
}
table tr:nth-child(even) {
  background:#ffeeee;
}
th.fc-sun {
  background: #a22 !important;
}
th.fc-sat {
  background: #22a !important;
}
.fc-event-container {
  background:#ffddff !important;
}
.fc-day-grid-event {
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  padding: 2px 6px;
  overflow: hidden;
}
.fc-content-skeleton {
  tr:nth-child(odd) {
    background: #f9f9f9 !important;
  }
  tr:nth-child(even) {
    background: #f9f9f9 !important;
  }
  /deep/.fc-event-container {
    background: #f9f9f9 !important;
  }
}
.fc-dayGridCustomDay-view > table > thead > tr > td > div > table {
  border-collapse: separate;
  border-spacing: 8px;
  border: none !important;
  background: #fff;
}
.fc-dayGridCustomDay-view > table > thead > tr > td > div > table > thead > tr > th {
  padding: 2px;
  border-radius: 4px;
}
.fc-dayGridCustomDay-view > table > tbody > tr > td > div > div > div > div > table {
  border-collapse: separate;
  border-spacing: 8px 0.5px;
  border: none !important;
  background: #fff;
}
.fc-dayGridCustomDay-view > table > tbody > tr > td > div > div > div > div > table > tbody > tr >td {
  border: none !important;
  border-radius: 4px;
  padding: 4px;
}
.fc-unthemed th, .fc-unthemed td, .fc-unthemed thead, .fc-unthemed tbody, .fc-unthemed .fc-divider, .fc-unthemed .fc-row, .fc-unthemed .fc-content, .fc-unthemed .fc-popover, .fc-unthemed .fc-list-view, .fc-unthemed .fc-list-heading td {
  border-color: #fff;
}
.fc-day-grid-event .fc-time {
  font-weight: 500;
}
// listview
.fc-list-table {
  border-collapse: separate;
  border-spacing: 8px;
  border: none !important;
  background: #fff;
}
.fc-list-table > tbody {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
}
.fc-list-table > tbody > tr {
  display: flex;
  flex-wrap: wrap;
  margin: 8px;
  width : calc(33% - 24px);
  min-width: 271px;
  height: 250px;
  overflow: hidden;
  background: #ffddff;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
  border-radius: 8px;
}
.fc-list-heading-main {
  margin-right: 8px;
}
.fc-list-item {
  cursor: pointer;
}
.fc-list-item-time {
  width: 100%;
  height: 24px !important;
  padding: 8px !important;
  padding-left: 16px !important;
  border: none !important;
}
.fc-list-item-title {
  width: calc(100% - 40px);
  margin-left: 8px;
  height: 24px !important;
  padding: 0px !important;
  border: none !important;
  overflow: hidden;
}
.fc-list-item-title > a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fc-list-item-marker {
  width: 32px;
  height: 24px !important;
  border: none !important;
}
.fc-event-dot {
  height: 16px;
  width: 16px;
  display: block;
  border-radius: 50%;
  margin: 4px;
  margin-left: 16px;
}
.fc-list-item:hover {
  background-color: #ffddff !important;
}
.fc-list-item:hover > td {
  background-color: #ffddff !important;
}
.fc-list-heading {
  width: 100% !important;
  height: auto !important;
  background: white !important;
  box-shadow: none !important;
}
.fc-list-heading > td {
  width: 256px;
  padding: 8px;
  border-radius: 8px;
}
.fc-time-grid-event {
  overflow: hidden;
}

// snackbarを前面に表示
.notices {
  z-index: 3000000;
}

//vue-select
.vs__dropdown-menu::-webkit-scrollbar {
  width:  5px;
  height: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue